
import { defineComponent, PropType } from 'vue'
import FilterGeneric, { FilterChoice } from '~/components/Common/FilterGeneric.vue'
import { ScaSortT } from '~/types/reportTypes'

export default defineComponent({
  name: 'ScaTargetsSort',
  components: {
    FilterGeneric
  },
  model: {
    prop: 'selectedScaSortFilter',
    event: 'update-sca-sort-filter'
  },
  props: {
    selectedScaSortFilter: {
      type: String as PropType<ScaSortT>,
      required: true
    },
    sortFilters: {
      type: Object as PropType<{ [key in ScaSortT]?: FilterChoice }>,
      required: true
    },
    defaultLabel: {
      type: String,
      required: true
    }
  },
  computed: {
    scaSortFilter: {
      get() {
        return this.selectedScaSortFilter
      },
      set(val: ScaSortT) {
        this.$emit('update-sca-sort-filter', val)
      }
    },
    nextSort(): ScaSortT {
      return this.newSortValue(this.scaSortFilter)
    }
  },
  methods: {
    newSortValue(scaSortFilter: ScaSortT): ScaSortT {
      if (scaSortFilter === ScaSortT.TOTAL_ASCENDING) {
        return ScaSortT.TOTAL_DESCENDING
      } else if (scaSortFilter === ScaSortT.TOTAL_DESCENDING) {
        return '' as ScaSortT
      } else {
        return ScaSortT.TOTAL_ASCENDING
      }
    }
  }
})
